/**
 * This file is copied from SelfServiceForms.
 */
import classes from './downloadBillLoader.scss';
const DownloadBillLoader = (props) => {
    return (
        <div className={classes.loaderContent}>
            <span>
                {props.msg || "Loading..."}
            </span>
            <div className={classes.loader}>
                <div>{""}</div>
                <div>{""}</div>
                <div>{""}</div>
            </div>
        </div>
    );
};
export default DownloadBillLoader;